(() => {
  const root = document.documentElement;
  const hero = document.querySelector('[data-wrn-hero]');
  if (hero) root.classList.add('wrn-home');

  const onScroll = () => {
    if (!hero) return;
    root.classList.toggle('wrn-scrolled', window.scrollY > 24);
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  const reveal = () => {
    const nodes = document.querySelectorAll('.wrn-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      nodes.forEach((n) => n.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    nodes.forEach((n) => io.observe(n));
  };
  reveal();

  document.addEventListener('shopify:section:load', reveal);

  document.addEventListener('change', (e) => {
    const select = e.target.closest('[data-wrn-variant-select]');
    if (!select) return;
    const form = select.closest('form');
    if (!form) return;
    const idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.value = select.value;
  });
})();
